import {User} from '@app/core/models/user.model';
import {RDate} from '@app/core/models/rDate.model';
import {InternationalizationService} from '@app/core/services/internationalization.service';
import {BaseModel} from '@app/core/models/base.model';

export class BulletinBoardPostComment extends BaseModel {
	public id: number;
	public user: User;
	public comment: string;
	public created_at: RDate;
	public updated_at: RDate;

	constructor(tenantTZ: string, interService: InternationalizationService) {
		super(tenantTZ, interService);
	}

	public deserialize(input: any): this {
		Object.assign(this, input);
		if (input.user) {
			this.user = new User(this.tenantTZ, this.interService).deserialize(input.user);
		}
		if (input.created_at) {
			this.created_at = new RDate(this.tenantTZ, this.interService).deserialize(input.created_at);
		}
		if (input.updated_at) {
			this.updated_at = new RDate(this.tenantTZ, this.interService).deserialize(input.updated_at);
		}

		return this;
	}
}
